<div class="row section-row" [formGroup]="parentFormGroup">
  <div class="col-3 section-col">
    <app-text
      [formElementModel]="nameFormElementModel"
      [parentFormGroup]="parentFormGroup"
    >
    </app-text>
  </div>
  <div class="col-3 section-col">
    <app-text
      [formElementModel]="emailFormElementModel"
      [parentFormGroup]="parentFormGroup"
    >
    </app-text>
  </div>
  <div class="col-3 section-col">
    <app-text
      [formElementModel]="phoneFormElementModel"
      [parentFormGroup]="parentFormGroup"
    >
    </app-text>
  </div>
  <div class="col-3 section-col">
    <div class="d-inline-block w-50 align-top">
      <app-text
        [formElementModel]="phoneExtFormElementModel"
        [parentFormGroup]="parentFormGroup"
      >
      </app-text>
    </div>
    <div class="d-inline-block w-50 align-top inject-content">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="col-12 section-col">
    <mat-error
      class="invalid-feedback fields-row-error"
      *ngIf="
        parentFormGroup.invalid &&
        (parentFormGroup.dirty || parentFormGroup.touched)
      "
    >
      <div *ngIf="parentFormGroup.errors?.['invalidContactPerson']">
        {{ parentFormGroup.errors?.['errorMsg'] }}
      </div>
    </mat-error>
  </div>
</div>
